import { FC, useState } from "react";
import styles from "./ChangingLogo.module.sass";
import cn from "classnames";
import { Button } from "components/shared";
import { useAppDispatch, useAppSelector } from "toolkit/hooks";
import { setOrganizationLogo } from "toolkit/organizations/organizations.thunks";

interface ChangingLogoProps {
	close: () => void;
}

export const ChangingLogo: FC<ChangingLogoProps> = ({ close }) => {
	const [logo, setLogo] = useState<any>(null);
	const dispatch = useAppDispatch();
	const { selectedOrganization } = useAppSelector((state) => state.organizations);

	const logoHandler = (files: FileList | null) => {
		if (files?.length) setLogo(files![0]);
	};

	const submitHandler = () => {
		dispatch(
			setOrganizationLogo({
				id: selectedOrganization!.id,
				logo,
			}),
		);
		close();
	};

	return (
		<section className={styles.wrp}>
			<h4 className={styles.title}>Изменить логотип</h4>
			{logo && <img className={styles.logo} src={URL.createObjectURL(logo)} alt="" />}
			<span className={styles.subtitle}>
				Вы можете загрузить изображение в формате JPG или PNG, размером 40x40 пикселей
			</span>
			{logo && (
				<div className={styles.btns}>
					<label className={cn(styles.label, styles.button, styles.changing)} htmlFor="logo">
						Изменить
					</label>
					<Button onClick={submitHandler} className={styles.button}>
						Готово
					</Button>
				</div>
			)}
			{!logo && (
				<>
					<label className={cn(styles.label, styles.choosing)} htmlFor="logo">
						Выбрать изображение
					</label>
				</>
			)}
			<input onChange={(e) => logoHandler(e.target.files)} type="file" id="logo" className="none" accept=".png, .jpg" />
		</section>
	);
};
